// Debug utility for deployment troubleshooting
import { config } from "./config";

export const debugEnvironment = () => {
  console.group("🔧 Environment Debug Information");
  
  // Basic environment info
  console.log("🌍 Environment Details:", {
    mode: import.meta.env.MODE,
    dev: import.meta.env.DEV,
    prod: import.meta.env.PROD,
    base: import.meta.env.BASE_URL,
    location: window.location.href,
    origin: window.location.origin,
    pathname: window.location.pathname,
    search: window.location.search
  });

  // Environment variables (safe for production)
  console.log("🔑 Environment Variables:", {
    VITE_API_URL: import.meta.env.VITE_API_URL || "❌ Not set",
    VITE_APP_URL: import.meta.env.VITE_APP_URL || "❌ Not set",
    VITE_SENTRY_DSN: import.meta.env.VITE_SENTRY_DSN ? "✅ Set" : "❌ Not set",
    VITE_FRIGADE_API_KEY: import.meta.env.VITE_FRIGADE_API_KEY ? "✅ Set" : "❌ Not set",
    VITE_MIXPANEL_TOKEN: import.meta.env.VITE_MIXPANEL_TOKEN ? "✅ Set" : "❌ Not set"
  });

  // Resolved config
  console.log("⚙️ Resolved Config:", {
    apiUrl: config.apiUrl,
    appUrl: config.appUrl,
    sentry: {
      dsn: config.sentry.dsn ? "configured" : "missing",
    },
    environment: config.environment,
    frigade: {
      apiKey: config.frigade.apiKey ? "configured" : "missing"
    },
    mixpanel: {
      token: config.mixpanel.token ? "configured" : "missing",
      persistence: config.mixpanel.persistence
    }
  });

  // Browser capabilities
  console.log("🌐 Browser Info:", {
    userAgent: navigator.userAgent,
    language: navigator.language,
    cookieEnabled: navigator.cookieEnabled,
    onLine: navigator.onLine,
    platform: navigator.platform,
    localStorage: (() => {
      try {
        localStorage.setItem('test', 'test');
        localStorage.removeItem('test');
        return '✅ Available';
      } catch {
        return '❌ Not available';
      }
    })(),
    sessionStorage: (() => {
      try {
        sessionStorage.setItem('test', 'test');
        sessionStorage.removeItem('test');
        return '✅ Available';
      } catch {
        return '❌ Not available';
      }
    })()
  });

  // Network connectivity test
  console.log("🔌 Testing API connectivity...");
  fetch(config.apiUrl + '/health', { method: 'GET' })
    .then(response => {
      console.log("✅ API Health Check:", {
        status: response.status,
        statusText: response.statusText,
        ok: response.ok
      });
    })
    .catch(error => {
      console.error("❌ API Health Check Failed:", {
        error: error.message,
        apiUrl: config.apiUrl
      });
    });

  console.groupEnd();
};

// Run debug on module load if in development or if debug flag is set
if (import.meta.env.DEV || window.location.search.includes('debug=true')) {
  debugEnvironment();
}
